import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { useDispatch } from "react-redux"
import { showToastMessage } from "../../../stateManagement/reducers"
import { Loader } from "../../loaders/Loader"
import { fetchDocumentView } from "../../../api/documentsApi"
import ZoomableImage from "../../zoomableImage/ZoomableImage"

export default function CustomDocumentViewerImage() {
    const dispatch = useDispatch()
    const { documentId }: any = useParams()
    const [documentIsLoading, setDocumentIsLoading] = useState<boolean>(true)
    const [documentImageSrc, setDocumentImageSrc] = useState<any>(null)

    async function getDocumentFile() {
        setDocumentIsLoading(true)
        const file = await fetchDocumentView(documentId)
        if (file) {
            if (file instanceof Blob) {
                const fileURL = URL.createObjectURL(file)
                setDocumentImageSrc(fileURL)
            } else {
                dispatch(showToastMessage({ messageText: "Возникла ошибка при загрузке документа для просмотра", messageType: "error" }))
            }
        }
        setDocumentIsLoading(false)
    }

    useEffect(() => {
        getDocumentFile()
    }, [documentId])

    return (
        <>
            {documentIsLoading && <Loader />}
            <div id="document-image-viewer-div">
                {documentImageSrc && <ZoomableImage src={documentImageSrc} />}
            </div>
        </>
    )
}
